import React, { useEffect, useState } from "react"
import Element from "@bappweb/element"
import Panel from "@bappweb/panel"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"
import Table from "./table"
import List from "@bappweb/list"
import { getCidParameter, getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"
import { useAppSelector } from "../../../config/hook"

const Campaign = () => {
    const sessionData = useAppSelector((state) => state.sessionData.response)

    const size = useDeviceSize()
    const [campaingsTable, setCampaingsTable] = useState<any[]>([]);
    const [campaingsHeader, setCampaingsHeader] = useState<any[] | null>(null);
    const [campaingsHeaderMobil, setCampaingsHeaderMobil] = useState<any[] | null>(null);
    const [campaingsTableText, setCampaingsTableText] = useState('');
    let cidParameter = getCidParameter();
    useEffect(() => {
        if (sessionData?.configList) {
            if (cidParameter != null) {
                let configText = size == Sizes.xs ? `PosLead.CampaignText.Landing.Table.Mobile.${cidParameter}` : `PosLead.CampaignText.Landing.Table.${cidParameter}`
                if (!isNullOrEmpty(getConfigValue(sessionData?.configList, configText))) {
                    const campaignRefList = JSON.parse(getConfigValue(sessionData?.configList, configText)) ?? []
                    setCampaingsTable(campaignRefList)
                }
                else {
                    let configText = size == Sizes.xs ? "PosLead.CampaignText.Landing.Table.Mobile" : "PosLead.CampaignText.Landing.Table"
                    if (!isNullOrEmpty(getConfigValue(sessionData?.configList, configText))) {
                        const campaignRefList = JSON.parse(getConfigValue(sessionData?.configList, configText)) ?? []
                        setCampaingsTable(campaignRefList)
                    }
                }
            }
            else {
                let configText = size == Sizes.xs ? "PosLead.CampaignText.Landing.Table.Mobile" : "PosLead.CampaignText.Landing.Table"
                if (!isNullOrEmpty(getConfigValue(sessionData?.configList, configText))) {
                    const campaignRefList = JSON.parse(getConfigValue(sessionData?.configList, configText)) ?? []
                    setCampaingsTable(campaignRefList)
                }
            }
        }
    }, [sessionData, size])

    useEffect(() => {
        if (sessionData?.configList) {
            if (cidParameter != null) {
                if (!isNullOrEmpty(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Table.Header.${cidParameter}`))) {
                    setCampaingsHeader(JSON.parse(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Table.Header.${cidParameter}`)))
                }
                else {
                    if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Table.Header"))) {
                        setCampaingsHeader(JSON.parse(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Table.Header")))
                    }
                }
            }
            else {
                setCampaingsHeader(JSON.parse(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Table.Header")))
            }
        }
    }, [sessionData])

    useEffect(() => {
        if (sessionData?.configList) {
            if (cidParameter != null) {
                if (!isNullOrEmpty(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Table.Mobile.Header.${cidParameter}`))) {
                    setCampaingsHeaderMobil(JSON.parse(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Table.Mobile.Header.${cidParameter}`)))
                }
                else {
                    if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Table.Mobile.Header"))) {
                        setCampaingsHeaderMobil(JSON.parse(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Table.Mobile.Header")))
                    }
                }
            }
            else {
                setCampaingsHeaderMobil(JSON.parse(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Table.Mobile.Header")))
            }
        }
    }, [sessionData])

    useEffect(() => {
        if (sessionData?.configList) {
            if (cidParameter != null) {
                if (!isNullOrEmpty(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Table.Text.${cidParameter}`))) {
                    setCampaingsTableText(getConfigValue(sessionData?.configList, `PosLead.CampaignText.Landing.Table.Text.${cidParameter}`))
                }
                else {
                    if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Table.Text"))) {
                        setCampaingsTableText(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Table.Text"))
                    }
                }
            }
            else {
                setCampaingsTableText(getConfigValue(sessionData?.configList, "PosLead.CampaignText.Landing.Table.Text"))
            }
        }
    }, [sessionData])

    return (
        <Page padding={false}>
            <Panel hasFooter={false} noHeader className="accordion-container">
                <Element type="h2" dangerouslySetInnerHTML={{ __html: campaingsTableText }} />
                <List
                    accordion
                    accordionCollapsible
                    activeItem={0}
                    custom={false}
                    disabled={false}
                    expandOnlyOne
                    withPadding
                    withoutBorder={false}
                >
                    <List.Item
                        accordion={false}
                        accordionCollapsible
                        disabled={false}
                        preventDefault
                        title={"Kampanyalar/ Oran Tablosu"}
                        withPadding={true}
                    >
                        {campaingsTable && campaingsHeader && campaingsHeaderMobil && campaingsTable.map((item, index) => {
                            return (<Table key={index} tableData={item.data} index={index} campaingsHeader={campaingsHeader} campaingsHeaderMobil={campaingsHeaderMobil} />)
                        })}
                    </List.Item>
                </List>
            </Panel>
        </Page>
    )
}

export default Campaign
